








































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LbzTopAppBar extends Vue {
  // type: 'standard' (default), 'extended', 'short'
  @Prop({ type: String, default: '' }) private type!: string;
  // background (auto-darkened): 'primary' (default), 'secondary', 'surface', 'light', 'dark', 'transparent'
  @Prop({ type: String, default: '' }) private background!: string;
  // fixed: true, false (default)
  @Prop({ type: Boolean, default: false }) private fixed!: boolean;
  // dense (desktop only): undefined (default), true, false
  @Prop({ type: Boolean, default: undefined }) private dense!: boolean;
  // elevated: true, false (default)
  @Prop({ type: Boolean, default: false }) private elevated!: boolean;
  // inactive (type === 'standard'): '' (default), 'scroll-off', 'tab-fixed'
  @Prop({ type: String, default: '' }) private inactive!: string;
  // media (type === 'extended'): '' (default), 'x'
  @Prop({ type: String, default: '' }) private media!: string;
  // title: '' (default), 'x'
  @Prop({ type: String, default: '' }) private title!: string;

  get cisDense(): boolean {
    return this.dense === undefined ? this.$lbzui.dense : this.dense;
  }
}
